exports = module.exports = require("../../../../node_modules/react-scripts/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ReactModal__Overlay {\n    z-index: 20;\n}", ""]);

// exports
